// extracted by mini-css-extract-plugin
export default {"root":"filter_label-module___root___e747ff0f","iconContainer":"filter_label-module___iconContainer___f28454db","icon":"filter_label-module___icon___bee1e0b6"};